import {UTM_PARAMETERS} from '@teladoc/fe-ccm/ui/config';
import CommonUtils from './common-utils';

export const getDomainName = () => {
    return window.location.hostname?.split('.')?.splice(-2)?.join('.');
};

/**
 * Extracts UTM parameters from a search string.
 * @param {string} [search=window.location.search] Raw search string (including leading '?').
 * @returns {Record<string, string>} Key-value map of UTM params (empty if none).
 */
export const extractUtmParams = (search = window.location.search) => {
    if (!search || !/utm_/i.test(search)) {
        return {};
    }

    // eslint-disable-next-line node/prefer-global/url-search-params
    const params = new URLSearchParams(search);
    const utmParams = {};

    params.forEach((value, key) => {
        if (/^utm_/i.test(key) && value) {
            utmParams[key] = value;
        }
    });

    return utmParams;
};

/**
 * Extracts UTM parameters from the URL search string and stores them in a cookie.
 * This enables UTM attribution tracking across navigation and API requests.
 * @param {string} [search=window.location.search] Raw search string (including leading '?').
 * Side effect: sets a cookie with the extracted UTM parameters if any are found.
 */
export const persistUtmCookie = (search = window.location.search) => {
    const utmParams = extractUtmParams(search);

    if (!Object.keys(utmParams).length) {
        return;
    }

    CommonUtils.setCookie({
        key: UTM_PARAMETERS,
        value: JSON.stringify(utmParams),
    });
};
